/*
  dropedo: eigene Trefferliste im Suchfeld.

  Eine Spalte statt zwei. Jede Zeile trägt den echten Farbton als Fläche, dazu Marke,
  Farbcode, Farbname, Ausführung und Preis. Shopifys Vorschlagsliste (queries) bleibt
  aussen vor, weil sie aus ungefilterten Kundeneingaben stammt und bei einem Shop,
  in dem nach einem Code gesucht wird, nur einen Klick kostet.

  Treffer seit 01.10.2026 live aus Shopifys Vorschlagssuche (Titel, Schlagwörter, SKU), gerendert von
  sections/ds-suche-daten.liquid: Code, Name und Farbe aus den Metafeldern wie auf der Produktseite. Ein neues
  oder geändertes Set steht sofort richtig in der Suche, ohne Datei-Neubau.
  Aus Dateien nur noch Standox-Wissen: Markenseiten und Töne ohne eigenes Set (Wunschfarbe) aus
  assets/lackkugel-daten.json, andere Schreibweisen desselben Tons aus assets/lackflaeche-alias.json.
  Erst ab zwei Zeichen, ein einzelner Buchstabe trifft sonst alles.

  Kombi-Codes seit 07.10.2026 (Antons „mach Suche bauen“): Hyundai W5 steht nicht für einen Farbton, sondern für zwei,
  U7 Oyster Blue (Karosserie) und XA Mauve Grey (Stoßfänger), jeder ein eigenes Set. Wer den Code tippt, sieht die Teile
  mit ihrer Rolle wie auf der Produktseite („Hauptfarbe für Code W5 · Karosserie“), nie „U7 / W5“ (das hieße: derselbe
  Ton) und nie W5R Wine Red, nur weil der Code so anfängt: unter den Teilen stehen nur Sets, die den Code wirklich tragen.
  Ein Teil ohne eigenes Set bekommt keine Zeile, er steht nur als Partner im Text („Für Code 7U mit R4 Solid Dark Grey“);
  bis zur Nachbesserung am selben Tag stand er als Wunschfarbe da (Anton: „solid dark grey taucht auf, wunschfarbe taucht
  auf“, meist ein Ton, den Standox gar nicht führt). Die
  Daten schreibt der Nachtschritt „Shop-Zweifarb“ (Werkbank skripte/zweifarb-theme.py) nach assets/zweifarb-codes.json;
  fehlt die Datei (Fehler 404, GemPages-Layouts ohne cfg.zweifarb), bleibt alles wie bisher. Dieselben Teile zeigt die
  Suchseite über dem Raster (sections/main-search.liquid) und die Startseite (assets/lackflaeche.js).

  Seit 21.10.2026 zeigt auch der Hero der Startseite diese Liste (Abschnitt „Eine Liste für alle Suchfelder“), und die
  allgemeine Wunschfarbe steht nur noch da, wo das Getippte nach einem Farbcode aussieht (codeArtig).
*/
(function () {
  'use strict';

  var MIN = 2;
  var MAX_LACK = 6;
  var MAX_ZUBEHOER = 3;
  var cfg = window.dropedoSuche || {};
  var datenP = null;
  var speicher = {};

  function norm(s) {
    return (s || '').toUpperCase().replace(/[\s\-_/.,()]/g, '');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function geld(wert) {
    var n = parseFloat(wert);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function bildUrl(u, breite) {
    if (!u) return '';
    var pfad = u.indexOf('//') === 0 ? 'https:' + u : u;
    if (/[?&]width=/.test(pfad)) return pfad;
    return pfad + (pfad.indexOf('?') >= 0 ? '&' : '?') + 'width=' + breite;
  }

  /* ---------- Farbdaten: einmal laden, alle Felder teilen sich das ---------- */

  function daten() {
    if (!datenP) {
      if (!cfg.daten) return Promise.resolve(null);
      datenP = fetch(cfg.daten, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(aufbereiten)
        .catch(function () { return null; });
    }
    return datenP;
  }

  function aufbereiten(d) {
    var marken = d.marken.map(function (m) {
      return {
        key: m[0],
        name: m[1],
        handle: m[2],
        anzahl: m[4],
        woerter: [norm(m[0]), norm(m[1])].filter(function (w, i, a) { return w && a.indexOf(w) === i; })
      };
    });
    return { marken: marken, toene: d.toene, cache: {} };
  }

  /* ---------- Live-Treffer und andere Schreibweisen ----------

     Shopify sucht wörtlich: „154A“ findet „154/A“ nicht, und eine Schreibweise, die weder im Titel noch als
     Schlagwort steht (A7W für LA7W), findet gar nichts. Deshalb fragt die Kopfsuche neben dem Getippten bis zu
     zwei weitere Codes ab: die Schreibweise der Tonliste, die anderen Schreibweisen desselben Tons
     (lackflaeche-alias.json, wie im Hero) und denselben Code mit Marke („VW 2T“). Bis 30.09.2026 stand diese
     Lücke als Index mit Handles und Preisen in kopfsuche-codes.json und musste nach jeder Produktänderung neu
     gebaut werden. */

  var RANG = ['VW', 'AUDI', 'BMW', 'MERCEDES', 'OPEL', 'FORD', 'SKODA', 'SEAT', 'TOYOTA', 'RENAULT', 'PEUGEOT',
    'CITROEN', 'FIAT', 'HYUNDAI', 'KIA', 'NISSAN', 'MAZDA', 'HONDA', 'VOLVO', 'PORSCHE', 'DACIA', 'MINI', 'SUZUKI', 'MITSUBISHI'];
  function rang(key) { var i = RANG.indexOf(key); return i < 0 ? 99 : i; }
  // Farbabstand ΔE (CIE76) zwischen zwei Hexwerten, wie in assets/lackflaeche.js: unter 10 derselbe Standox-Ton
  function lab(hex) {
    var n = parseInt(String(hex).replace('#', ''), 16);
    var c = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function (v) {
      v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    var f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
    var x = f((c[0] * 0.4124 + c[1] * 0.3576 + c[2] * 0.1805) / 0.95047);
    var y = f(c[0] * 0.2126 + c[1] * 0.7152 + c[2] * 0.0722);
    var z = f((c[0] * 0.0193 + c[1] * 0.1192 + c[2] * 0.9505) / 1.08883);
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  }
  function dE(a, b) { var A = lab(a), B = lab(b); return Math.hypot(A[0] - B[0], A[1] - B[1], A[2] - B[2]); }
  // Zwei Farbnamen teilen ein Wort ab vier Buchstaben („Misano Blau“ / „Misanoblau“)
  function woerter(s) { return String(s || '').toUpperCase().split(/[^A-Z0-9ÄÖÜ]+/).filter(function (w) { return w.length >= 4; }); }
  function namenNah(a, b) {
    var an = norm(a), bn = norm(b);
    return woerter(a).some(function (w) { return bn.indexOf(w) >= 0; }) || woerter(b).some(function (w) { return an.indexOf(w) >= 0; });
  }
  var KONZERN = ['VW', 'AUDI', 'SEAT', 'SKODA', 'PORSCHE'];
  // wie assets/lackflaeche.js
  var MARKE_ALIAS = { VOLKSWAGEN: 'VW', MERCEDESBENZ: 'MERCEDES', MB: 'MERCEDES', BENZ: 'MERCEDES', CUPRA: 'SEAT',
    ALFA: 'ALFA ROMEO', ALFAROMEO: 'ALFA ROMEO', LANDROVER: 'LAND ROVER', HARLEYDAVIDSON: 'HARLEY' };

  // Farbwörter in mehreren Sprachen (Anton 01.10.2026): Die Farbnamen stehen in der Sprache des Herstellers,
  // wer „weiß“ tippt, soll auch WHITE, BLANC und BIANCO finden. Je Gruppe nach Häufigkeit in den Farbnamen des
  // Shops (Zählung 01.10.2026); gefragt werden die zwei häufigsten außer dem getippten. Dieselbe Liste steht in
  // assets/lackflaeche.js.
  var FARBWOERTER = [
    ['WHITE', 'BLANC', 'BIANCO', 'BLANCO', 'WEISS', 'BRANCO'],
    ['BLACK', 'NERO', 'SCHWARZ', 'NOIR', 'NEGRO', 'PRETO'],
    ['GREY', 'GRIS', 'GRAY', 'GRIGIO', 'GRAU', 'CINZA'],
    ['SILVER', 'SILBER', 'ARGENT', 'ARGENTO', 'PRATA', 'PLATA'],
    ['BLUE', 'BLEU', 'AZUL', 'BLU', 'BLAU', 'AZZURRO'],
    ['RED', 'ROUGE', 'ROSSO', 'ROJO', 'ROT', 'VERMELHO'],
    ['GREEN', 'VERDE', 'VERT', 'GRUN', 'GRUEN'],
    ['YELLOW', 'JAUNE', 'GIALLO', 'GELB', 'AMARILLO', 'AMARELO'],
    ['BROWN', 'MARRON', 'MARRONE', 'BRAUN', 'MARROM'],
    ['ORANGE', 'ARANCIO', 'LARANJA'],
    ['PURPLE', 'VIOLET', 'VIOLETT', 'VIOLA', 'LILA'],
    ['GOLD', 'ORO', 'DORADO'],
    ['BEIGE', 'BEGE'],
    ['TURQUOISE', 'TURKIS', 'TUERKIS', 'TURCHESE'],
    ['ANTHRAZIT', 'ANTHRACITE', 'ANTRACITE']
  ];
  // Deutsche Farbwörter stehen oft am Ende eines Namens (MISANOROT, CANDYWEISS), die anderen nicht (COLOURED ist kein RED)
  var FARB_ENDE = ['WEISS', 'SCHWARZ', 'GRAU', 'SILBER', 'BLAU', 'ROT', 'GRUN', 'GRUEN', 'GELB', 'BRAUN', 'VIOLETT',
    'GOLD', 'BEIGE', 'ORANGE', 'TURKIS', 'TUERKIS', 'ANTHRAZIT'];
  function farbNorm(s) {
    return String(s || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Z0-9]/g, '');
  }
  function farbGruppe(wort) {
    var n = farbNorm(wort);
    for (var i = 0; i < FARBWOERTER.length; i++) if (FARBWOERTER[i].indexOf(n) >= 0) return FARBWOERTER[i];
    return null;
  }
  function farbWortIn(name, gruppe) {
    var teile = String(name || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '').split(/[^A-Z0-9]+/);
    return teile.some(function (t) {
      return t && gruppe.some(function (w) {
        return t === w || (w.length >= 4 && t.indexOf(w) === 0) ||
          (FARB_ENDE.indexOf(w) >= 0 && t.length > w.length && t.slice(-w.length) === w);
      });
    });
  }
  // Ein Farbwort, mit oder ohne Marke davor („VW weiß“): zwei weitere Anfragen („VW WHITE“, „VW BLANC“). Mit Umlaut
  // zuerst die ue-Schreibweise der Titel („grün“ -> GRUEN, Shopify findet GRUEN mit „grün“ nicht)
  function farbFragen(D, wort) {
    var WN = norm(wort), mt = D ? markeImWort(D, WN) : null;
    var rest = mt ? WN.split(norm(mt.marke.key)).join('').split(norm(mt.marke.name)).join('') : WN;
    var gruppe = farbGruppe(rest);
    if (!gruppe) return null;
    var n = farbNorm(rest);
    var ue = rest.replace(/Ä/g, 'AE').replace(/Ö/g, 'OE').replace(/Ü/g, 'UE');
    var dazu = (ue !== n && gruppe.indexOf(ue) >= 0 ? [ue] : [])
      .concat(gruppe.filter(function (w) { return w !== n && w !== ue; }));
    return {
      gruppe: gruppe,
      fragen: dazu.slice(0, 2).map(function (w) { return ((mt ? mt.marke.name + ' ' : '') + w).trim(); })
    };
  }

  var aliasP = null;
  function aliasse() {
    if (!aliasP) {
      if (!cfg.alias) return Promise.resolve(null);
      aliasP = fetch(cfg.alias, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.a ? j.a : null; })
        .catch(function () { return null; });
    }
    return aliasP;
  }

  var zweifarbP = null;
  function zweifarb() {
    if (!zweifarbP) {
      if (!cfg.zweifarb) return Promise.resolve(null);
      zweifarbP = fetch(cfg.zweifarb, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.k ? j.k : null; })
        .catch(function () { return null; });
    }
    return zweifarbP;
  }

  // Die alten Sets „W5 OEM MULTI TONE“ (bis zu ihrer Archivierung): nie ein Einzelton, am Namen erkannt, nie am Handle
  // (Opel 40K behält „oem-multi-tone“ im Handle und heißt Yellow Punch)
  var MEHRFARB = /MULTI\s*-?\s*TONE/i;

  // Kombi-Codes zum Getippten, nur der ganze Code („Hyundai BY“ bleibt BY Prime Green, erst „BY HC“ ist die Kombi). Mit Marke
  // nur diese Marke, ohne Marke jede Marke mit dem Code, nach RANG. [{ key, marke, code, paare }]
  function kombiTreffer(D, Z, wort) {
    if (!D || !Z) return [];
    var WN = norm(wort), mt = markeImWort(D, WN);
    var rest = mt ? WN.split(norm(mt.marke.key)).join('').split(norm(mt.marke.name)).join('') : WN;
    if (rest.length < 2) return [];
    var schl = mt ? [mt.marke.key + '|' + rest]
      : Object.keys(Z).filter(function (k) { return k.slice(k.indexOf('|') + 1) === rest; })
          .sort(function (a, b) { return rang(a.slice(0, a.indexOf('|'))) - rang(b.slice(0, b.indexOf('|'))); });
    return schl.filter(function (k) { return Z[k] && Z[k].paare && Z[k].paare.length; }).map(function (k) {
      var key = k.slice(0, k.indexOf('|')), marke = null;
      for (var i = 0; i < D.marken.length; i++) if (D.marken[i].key === key) { marke = D.marken[i]; break; }
      return { key: key, marke: marke || { key: key, name: key, handle: '', woerter: [norm(key)] }, code: Z[k].code, paare: Z[k].paare };
    });
  }

  function kombiHandles(kz) {
    var hs = [];
    kz.forEach(function (k) {
      k.paare.forEach(function (pa) {
        pa.teile.forEach(function (t) { if (t.h && hs.indexOf(t.h) < 0) hs.push(t.h); });
      });
    });
    return hs;
  }

  // Wortlaut wie auf der Produktseite (snippets/ds-zweifarb.liquid): „Hauptfarbe für Code W5 · Karosserie“, Jahre, wenn der Code
  // für mehr als ein Paar steht (VW 9915). Ohne belegte Rolle stünde auf beiden Teilen „Zweite Farbe“; dann nennt die Zeile den
  // Partner: „Für Code BD mit BC Polar Grey“.
  function kombiText(k, pa, t) {
    var zusatz = k.paare.length > 1 && pa.jahre ? ' (' + String(pa.jahre).replace('-', ' bis ') + ')' : '';
    if (t.art === 'Hauptfarbe' || t.art === 'Zweitfarbe') return t.art + ' für Code ' + k.code + zusatz + (t.wo ? ' · ' + t.wo : '');
    var partner = pa.teile.filter(function (x) { return x !== t; })[0];
    return 'Für Code ' + k.code + zusatz + (partner ? ' mit ' + partner.code + ' ' + partner.name : '');
  }

  // Je Teil mit eigenem Set eine Zeile, Paar für Paar, Hauptfarbe zuerst. Ein Teil ohne Set steht nur im Text seines Partners.
  // Ein Teil in zwei Paaren (Hyundai WI: NW mit HC bis 2003, mit PE ab 2004) steht je Paar einmal, mit den Jahren. Preis und Foto
  // aus der Live-Antwort, sonst aus /products/<handle>.js; ein Set, das seit der Nacht verschwunden ist, fällt weg.
  function kombiZeilen(kz, produkte, pj) {
    var aus = [];
    kz.forEach(function (k) {
      k.paare.forEach(function (pa) {
        pa.teile.forEach(function (t) {
          if (!t.h) return;
          var d = { lack: true, marke: k.marke, code: t.code, name: t.name, codes: {},
                    ton: t.hex ? [t.code, t.name, t.hex, t.e ? 1 : 0] : null };
          var kombi = { text: kombiText(k, pa, t) };
          var p = null;
          for (var i = 0; i < (produkte || []).length; i++) if (produkte[i].handle === t.h) { p = produkte[i]; break; }
          if (!p && pj && pj[t.h]) p = ausProduktJs(pj[t.h]);
          if (p) aus.push({ p: p, d: d, kombi: kombi });
        });
      });
    });
    return aus;
  }

  // Shopifys Vorschlagssuche, je Treffer mit seinen Metafeldern (sections/ds-suche-daten.liquid)
  function liveSuche(q, signal) {
    var url = (cfg.suche || '/search') + '/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' +
      '&section_id=ds-suche-daten';
    return fetch(url, { signal: signal, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/<script[^>]*id="ds-suche-daten"[^>]*>([\s\S]*?)<\/script>/);
        var liste = [];
        try { liste = m ? JSON.parse(m[1]) : []; } catch (e) { liste = []; }
        return liste.map(function (x) {
          return { title: x.t, url: '/products/' + x.h, handle: x.h, image: x.b,
                   price: x.pn / 100, price_min: x.pn / 100, price_max: x.px / 100, mf: x };
        });
      });
  }

  function markeAusMetafeld(D, wert) {
    var n = norm(wert);
    if (!n) return null;
    n = norm(MARKE_ALIAS[n] || n);
    if (D) for (var i = 0; i < D.marken.length; i++) if (D.marken[i].woerter.indexOf(n) >= 0) return D.marken[i];
    // Marke ohne eigene Seite in der Farbdatei (Chrysler): Name wie im Metafeld
    return { key: n, name: String(wert).trim(), handle: '', woerter: [n] };
  }

  // Codes im Titel: „Lackstift Set für VW LC9X / 2T DEEPBLACK 20ml“ -> LC9X, 2T; auch „passend für“ und
  // „FIAT / LANCIA 164/B“ (dort steht im Metafeld oft nur 164)
  function titelCodes(titel) {
    var t = String(titel || '').replace(/^\s*Lackstift(\s+Set)?(\s+passend)?(\s+für)?\s+/i, '');
    var m = t.match(/^(\S+(?:\s+ROMEO|\s+ROVER|\s*\/\s*LANCIA)?)\s+(.+?)\s+\d+\s*(?:x\s*\d+\s*)?ml/i);
    if (!m) return [];
    var teile = m[2].split(/\s+/), roh = [teile[0]], i = 1;
    while (teile[i] === '/' && teile[i + 1]) { roh.push(teile[i + 1]); i += 2; }
    // „594/B“ ist ein Code, „W9877/BC“ führt auch BC: beide Lesarten zählen (wie im Hero)
    var aus = [];
    roh.forEach(function (r) {
      aus.push(norm(r));
      r.split('/').forEach(function (s) { if (norm(s).length >= 2) aus.push(norm(s)); });
    });
    return aus.filter(Boolean);
  }

  // Ein Treffer aus seinen Metafeldern, wie die Produktseite ihn zeigt. Ohne Farbwert kein Farbpunkt (die
  // Produktseite zeigt dann auch keinen), statt eines geratenen Standox-Tons. codes: alle Codes, unter denen
  // das Set läuft (Metafeld, Titel, Zweitcodes als Schlagwort, wie in ds-produktdaten.liquid).
  function ausMetafeldern(p, D) {
    var m = p.mf;
    if (!m || !m.c || (p.title || '').toUpperCase().indexOf('LACKSTIFT') < 0) return null;
    var marke = markeAusMetafeld(D, m.m);
    if (!marke) return null;
    var hex = m.x ? String(m.x).replace('#', '') : '';
    var codes = {};
    codes[norm(m.c)] = true;
    titelCodes(p.title).forEach(function (c) { codes[c] = true; });
    (m.tg || []).forEach(function (t) {
      if (t === t.toUpperCase() && t.length >= 2 && t.length <= 10 && !/[\s_-]/.test(t)) codes[norm(t)] = true;
    });
    return { lack: true, marke: marke, ton: hex ? [m.c, m.n || '', hex, m.e ? 1 : 0] : null,
             code: m.c, name: m.n || '', codes: codes };
  }

  // Weitere Anfragen zum Getippten, höchstens zwei: [{ key, code, codeN, frage }]
  function aliasZiele(D, A, wort) {
    if (!D) return [];
    var WN = norm(wort);
    var mt = markeImWort(D, WN);
    var rest = mt ? WN.split(norm(mt.marke.key)).join('').split(norm(mt.marke.name)).join('') : WN;
    if (rest.length < 2) return [];
    var getippt = String(wort).trim().toUpperCase().split(/\s+/).pop();
    var aus = [], gesehen = {};
    function dazu(key, code, mitMarke) {
      if (!code || (mt && key !== mt.marke.key)) return;
      // in der Schreibweise der Tonliste fragen, Shopify sucht wörtlich
      var liste = toeneVon(D, key), cn = norm(code), i, m = null;
      for (i = 0; i < liste.length; i++) if (liste[i].codeN === cn) { code = liste[i].ton[0]; break; }
      // So getippt fragt schon die erste Anfrage (mit Marke, wenn eine dastand)
      if ((mt || !mitMarke) && code.toUpperCase() === getippt) return;
      for (i = 0; i < D.marken.length; i++) if (D.marken[i].key === key) { m = D.marken[i]; break; }
      var frage = ((m ? m.name : key) + ' ' + code).trim();
      if (gesehen[frage]) return;
      gesehen[frage] = true;
      aus.push({ key: key, code: code, codeN: cn, frage: frage });
    }
    var marken = mt ? [mt.marke] : D.marken.slice().sort(function (a, b) { return rang(a.key) - rang(b.key); });
    // 1. dieselbe Schreibweise mit Trennzeichen (154A = 154/A)
    marken.forEach(function (m) {
      toeneVon(D, m.key).forEach(function (e) {
        if (e.codeN === rest && /[^A-Z0-9]/i.test(e.ton[0])) dazu(m.key, e.ton[0]);
      });
    });
    // 2. andere Schreibweisen desselben Tons (Standox, wie im Hero)
    if (A) {
      var schl = mt ? [mt.marke.key + '|' + rest]
        : Object.keys(A).filter(function (k) { return k.slice(k.indexOf('|') + 1) === rest; })
            .sort(function (a, b) { return rang(a.slice(0, a.indexOf('|'))) - rang(b.slice(0, b.indexOf('|'))); });
      schl.forEach(function (k) {
        (A[k] || []).forEach(function (z) {
          var i = z.indexOf('|');
          if (norm(z.slice(i + 1)) !== rest) dazu(z.slice(0, i), z.slice(i + 1));
        });
      });
    }
    // 3. VW-Konzern: „A7W“ meint „LA7W“
    if (rest.length === 3) {
      marken.forEach(function (m) {
        if (KONZERN.indexOf(m.key) < 0) return;
        if (toeneVon(D, m.key).some(function (e) { return e.codeN === 'L' + rest; })) dazu(m.key, 'L' + rest);
      });
    }
    // 4. derselbe Code mit Marke, damit das Set nicht hinter zehn Zufallstreffern verschwindet
    if (!mt) {
      marken.forEach(function (m) {
        if (rang(m.key) < 99 && toeneVon(D, m.key).some(function (e) { return e.codeN === rest; })) dazu(m.key, rest, true);
      });
    }
    return aus.slice(0, 2);
  }

  // Produkt als JSON (Foto für Treffer ohne Bild in der Suchantwort, Preis und Foto der Kombi-Teile), je Handle einmal
  var produktCache = {};
  function produktJs(handle) {
    if (!produktCache[handle]) {
      produktCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return produktCache[handle];
  }
  function fotoVon(handle) {
    return produktJs(handle).then(function (j) { return (j && (j.featured_image || (j.images && j.images[0]))) || ''; });
  }
  function ausProduktJs(j) {
    return { title: j.title, url: '/products/' + j.handle, handle: j.handle, image: j.featured_image || (j.images && j.images[0]) || '',
             price: j.price / 100, price_min: j.price_min / 100, price_max: j.price_max / 100 };
  }

  // Farbcodes einer Marke, einmal in Suchform gebracht
  function toeneVon(D, key) {
    if (!D.cache[key]) {
      D.cache[key] = (D.toene[key] || []).map(function (t) {
        return { codeN: norm(t[0]), nameN: norm(t[1]), ton: t };
      });
    }
    return D.cache[key];
  }

  /* ---------- Toene ohne eigenes Angebot ----------

     Die Kopfsuche fragt nur den Produktbestand. Wer „LW7X" eintippt und dafuer kein
     Angebot vorfindet, las bisher „Kein Treffer" — eine Sackgasse, obwohl wir den Ton
     sehr wohl anmischen. Die Kugel im Hero macht es an derselben Stelle richtig und
     bietet „Als Wunschfarbe bestellen" an.

     Dieselbe Auskunft gehoert in die Kopfsuche. Die Farbdaten liegen ohnehin schon
     geladen da, sie werden bisher nur fuer die Farbflaechen benutzt. */

  function markeImWort(D, WN) {
    var treffer = null;
    D.marken.forEach(function (m) {
      m.woerter.forEach(function (w) {
        if (w && WN.indexOf(w) >= 0 && (!treffer || w.length > treffer.laenge)) {
          treffer = { marke: m, laenge: w.length };
        }
      });
    });
    return treffer;
  }

  function toeneSuchen(D, wort, grenze) {
    if (!D || !D.toene) return [];
    var WN = norm(wort);
    if (WN.length < 2) return [];
    // Steht eine Marke im Suchwort, zaehlt nur diese Marke und der Rest ist der Code.
    var mt = markeImWort(D, WN);
    var marken = mt ? [mt.marke] : D.marken;
    var rest = mt ? WN.split(norm(mt.marke.key)).join('').split(norm(mt.marke.name)).join('') : WN;
    if (mt && rest.length < 2) rest = WN;

    var genau = [], teil = [];
    for (var i = 0; i < marken.length && genau.length < grenze; i++) {
      var m = marken[i];
      var liste = toeneVon(D, m.key);
      for (var j = 0; j < liste.length; j++) {
        var e = liste[j];
        if (e.codeN === rest || e.codeN === WN) {
          genau.push({ marke: m, ton: e.ton });
          if (genau.length >= grenze) break;
        } else if (teil.length < grenze &&
                   (e.codeN.indexOf(rest) === 0 || (rest.length >= 3 && e.nameN.indexOf(rest) >= 0))) {
          teil.push({ marke: m, ton: e.ton });
        }
      }
    }
    return genau.concat(teil).slice(0, grenze);
  }

  /* ---------- Aus einem Produkttitel Marke und Farbton lesen ---------- */

  // Alle Wortfolgen bis drei Teile, damit auch Codes wie "040 SA" oder "LA7W / 8E" treffen
  function kandidaten(titelGross) {
    var teile = titelGross.split(/[\s/,+]+/).map(norm).filter(Boolean);
    var menge = Object.create(null);
    for (var i = 0; i < teile.length; i++) {
      var zus = '';
      for (var k = 0; k < 3 && i + k < teile.length; k++) {
        zus += teile[i + k];
        if (zus.length > 12) break;
        menge[zus] = true;
      }
    }
    return menge;
  }

  function deuten(titel, D) {
    var T = (titel || '').toUpperCase();
    var erg = { lack: T.indexOf('LACKSTIFT') >= 0, marke: null, ton: null };
    if (!D) return erg;

    var TN = norm(T);
    var kand = kandidaten(T);
    var best = -1;

    D.marken.forEach(function (m) {
      var drin = m.woerter.some(function (w) { return TN.indexOf(w) >= 0; });
      if (!drin) return;
      toeneVon(D, m.key).forEach(function (e) {
        if (!kand[e.codeN]) return;
        // Ein Code allein ist nicht eindeutig, deshalb zählt der Farbname im Titel am meisten
        var punkte = (e.nameN && TN.indexOf(e.nameN) >= 0 ? 1000 : 0) + e.codeN.length;
        if (punkte > best) { best = punkte; erg.marke = m; erg.ton = e.ton; }
      });
    });
    return erg;
  }

  // Ausführung und Füllmengen kommen wörtlich aus dem Titel, nichts wird dazugerechnet
  function beschreibung(titel) {
    var T = (titel || '').toUpperCase();
    var teile = [];
    if (T.indexOf('GRUNDIERUNG') >= 0) teile.push('Mit Grundierung');
    else if (T.indexOf('GRUNDTON') >= 0) teile.push('Mit Grundton');
    else if (T.indexOf('KLARLACK') >= 0) teile.push('Set mit Klarlack');
    var mengen = titel.match(/\d+\s*x\s*\d+\s*ml|\d+\s*ml/gi);
    if (mengen) {
      teile.push(mengen.map(function (x) { return x.replace(/\s+/g, '').toLowerCase(); }).join(' + '));
    }
    return teile.join(' · ');
  }

  // Für Lackstifte ohne Farbmuster: aus dem Titel eine lesbare Zeile machen,
  // also Vorspann und Füllmengen weg und die geschriebenen Farbnamen entschreien
  function kurztitel(titel) {
    var t = (titel || '').replace(/^\s*Lackstift(\s+Set)?(\s+passend)?(\s+für)?\s+/i, '');
    var m = t.match(/\d+\s*x\s*\d+\s*ml|\d+\s*ml/i);
    if (m && m.index > 0) t = t.slice(0, m.index);
    t = t.replace(/[\s+,·-]+$/, '').trim();
    return t.replace(/[A-ZÄÖÜ]{5,}/g, function (w) { return w.charAt(0) + w.slice(1).toLowerCase(); });
  }

  function punktVon(d) {
    return d.lack && d.ton
      ? '<span class="ds-tr-punkt" data-lackart="' + (d.ton[3] ? 'effekt' : 'uni') + '" style="--ton:#' + esc(d.ton[2]) + '" aria-hidden="true"></span>'
      : '';
  }

  // Eine Trefferzeile als Link. In der Kopfliste führt die Liste den Fokus (aria-activedescendant), die Links selbst nicht
  function trefferLink(e, tab) {
    var p = e.p, d = e.d, ti = tab ? '' : ' tabindex="-1"';
    // Durchgaengig das Produktfoto (Anton, 24.09.2026). Vorher stand bei Lackstiften mit
    // bekanntem Ton nur die Farbflaeche, bei allen anderen das Foto. Der Ton sitzt jetzt als
    // Kaestchen oben rechts auf dem Foto, wie auf den Kategoriekarten.
    var fotoTag = p.image
      ? '<img class="ds-tr-bild" src="' + esc(bildUrl(p.image, 120)) + '" alt="" width="52" height="52" loading="lazy">'
      : (p.handle
        ? '<img class="ds-tr-bild" data-foto-von="' + esc(p.handle) + '" alt="" width="52" height="52">'
        : '<span class="ds-tr-probe ds-tr-probe--leer" aria-hidden="true"></span>');
    var bild = '<span class="ds-tr-foto">' + fotoTag + punktVon(d) + '</span>';
    var kopf, unter;
    if (e.kombi) {
      // Kombi-Teil: eigener Code und Name wie auf seiner Produktseite, darunter die Rolle im Kombi-Code
      kopf = d.marke.name + ' ' + d.code + ' ' + d.name;
      unter = e.kombi.text;
    } else if (d.lack && d.ton) {
      kopf = d.marke.name + ' ' + (e.anzeige || d.ton[0]) + ' ' + d.ton[1];
      unter = beschreibung(p.title || (p.handle || '').replace(/-/g, ' '));
    } else if (d.lack) {
      // Farbcode ohne Muster in unseren Daten, dann zeigt die Zeile das Produktfoto
      kopf = kurztitel(p.title);
      unter = beschreibung(p.title);
    } else {
      kopf = p.title;
      unter = '';
    }
    var preis = p.price_min && p.price_max && p.price_min !== p.price_max
      ? 'ab ' + geld(p.price_min)
      : geld(p.price);
    return '<a class="ds-tr" href="' + esc(p.url) + '"' + ti + '>' + bild +
      '<span class="ds-tr-text"><b>' + esc(kopf) + '</b>' +
      (unter ? '<small>' + esc(unter) + '</small>' : '') + '</span>' +
      '<span class="ds-tr-preis">' + esc(preis) + '</span></a>';
  }

  function fotosNachladen(wurzel) {
    Array.prototype.forEach.call(wurzel.querySelectorAll('img[data-foto-von]'), function (img) {
      fotoVon(img.getAttribute('data-foto-von')).then(function (u) { if (u) img.src = bildUrl(u, 120); });
    });
  }

  /* ---------- Eine Liste für alle Suchfelder ----------

     Bis 21.10.2026 rechnete jedes <ds-suchfeld> seine Liste in zeichnen(), und der Hero der Startseite
     (assets/lackflaeche.js) kannte nur Lackstifte: „Schleifpapier“, „Parksensor“ oder „Golf 7 schwarz“ endeten dort
     im Angebot, die Farbe anmischen zu lassen, während die Kopfsuche die Artikel fand. Anton: „nur eine Suche“.
     Seitdem fragen, ordnen und zeichnen alle Felder mit denselben Funktionen; der Hero holt sich die Liste über
     window.dropedoSucheMotor (unten) und rechnet nur die Farbtöne für Fläche und Karte selbst. */

  // Sieht das Getippte nach einem Farbcode aus? Nur dann bietet die Liste an, die Farbe anmischen zu lassen (Anton
  // 21.10.2026: nicht bei „Schleifpapier“). Nach der Marke höchstens acht Zeichen mit einer Ziffer darin oder höchstens
  // vier Zeichen ohne (DKSW, SOP); ein Farbwort („VW weiß“) zählt auch. Kennt Standox den Ton, steht er ohnehin als
  // „Auf Anfrage angemischt“ da. Dieselbe Regel steht in snippets/ds-kein-treffer.liquid (Suchseite ohne Treffer).
  function codeArtig(D, wort) {
    var WN = norm(wort), mt = D ? markeImWort(D, WN) : null;
    var rest = mt ? WN.split(norm(mt.marke.key)).join('').split(norm(mt.marke.name)).join('') : WN;
    if (rest.length < 2) rest = WN;
    if (farbGruppe(rest)) return true;
    return rest.length <= 8 && (/\d/.test(rest) || rest.length <= 4);
  }

  /* Produktsuche (21.10.2026, Anton: „soll alles richtig sein … best practice“): „3M Politur“ zeigte zuerst drei Farbtöne
     „Polaire“ (Shopifys Tippfehler-Nähe), „Klarlack“ zufällige Sets, deren Titel „+ Klarlack 20ml“ trägt, „Grundierung“ nur
     Sets und keine der drei Grundierungen. Bei einem Produktwort zählen deshalb die getippten Wörter in Titel, Produktart
     und Hersteller (sections/ds-suche-daten.liquid: y, vd). Bei Lackstiften zählen Wörter aus jedem Set-Titel und
     Markennamen nicht, sonst wäre jedes Set ein Treffer für „Klarlack“ oder „Mercedes Klarlack“. */
  var SET_WORT = /^(LACKSTIFTE?|LACKSTIFTSETS?|SETS?|LACK|KLARLACK|BASISLACK|GRUNDIERUNG|KUNSTSTOFFGRUNDIERUNG|METALLGRUNDIERUNG|GRUNDTON|PINSEL|FUER|FUR|PASSEND|\d+ML|ML)$/;
  // Wörter in Vergleichsform: Umlaute als AE/OE/UE (so stehen sie in den Titeln), ohne Akzente
  function vergleichsWoerter(s) {
    return String(s || '').toUpperCase().replace(/Ä/g, 'AE').replace(/Ö/g, 'OE').replace(/Ü/g, 'UE')
      .normalize('NFD').replace(/[̀-ͯ]/g, '').split(/[^A-Z0-9]+/).filter(Boolean);
  }
  function suchWoerter(wort) {
    return vergleichsWoerter(wort).filter(function (w) { return w.length >= 2; });
  }
  function istMarkenwort(D, w) {
    return !!D && D.marken.some(function (m) { return m.woerter.indexOf(w) >= 0; });
  }
  // Wie viele der getippten Wörter stehen am Produkt: am Wortanfang („Politur“ in „Politur 80349“), ab fünf Buchstaben
  // auch mitten im Wort („schleifpapier“ in „Nassschleifpapier“)
  // Punkte: ein Wort 2, ein Markenname nur 1 („VW Politur“: die Politur vor dem VW-Spiegelschalter, der nur „VW“ trägt;
  // so am 22.10.2026 auf der Markenseite gesehen). Bei Lackstiften zählen Marke und Set-Wörter gar nicht.
  function wortTreffer(qw, p, lack, D) {
    var mf = p.mf || {};
    var tw = vergleichsWoerter([p.title, mf.y, mf.vd].join(' '));
    return qw.reduce(function (summe, w) {
      var marke = istMarkenwort(D, w);
      if (lack && (SET_WORT.test(w) || marke)) return summe;
      var da = tw.some(function (t) { return t.indexOf(w) === 0 || (w.length >= 5 && t.indexOf(w) > 0); });
      return summe + (da ? (marke ? 1 : 2) : 0);
    }, 0);
  }
  // Produktart als eigene Anfrage („product_type:grundierung“, Shopifys Suchsyntax): das längste Wort ab fünf Buchstaben,
  // das keine Marke ist („Mercedes Klarlack“ fragt nach Klarlack)
  function typWort(wort, D) {
    var w = String(wort || '').trim().split(/[\s,;/+]+/).filter(function (x) {
      return x.length >= 5 && !/\d/.test(x) && !istMarkenwort(D, norm(x));
    });
    w.sort(function (a, b) { return b.length - a.length; });
    return w.length ? w[0].toLowerCase() : '';
  }

  // Nur wenn die Eingabe ausschliesslich aus dem Markennamen besteht
  function markeZu(wort, D) {
    if (!D) return null;
    var q = norm(wort);
    if (q.length < MIN) return null;
    var treffer = null;
    D.marken.forEach(function (m) {
      m.woerter.forEach(function (w) {
        if (w.indexOf(q) !== 0) return;
        if (!treffer || w.length < treffer.laenge) treffer = { marke: m, laenge: w.length };
      });
    });
    return treffer ? treffer.marke : null;
  }

  // Alle Anfragen zu einem Suchwort, je Wort einmal (speicher). Farbdaten, Schreibweisen und Kombi-Codes liegen nach dem
  // ersten Fokus schon da, dann laufen alle Anfragen zugleich. Die Sets der Kombi-Teile kommen direkt über ihren Handle:
  // die Vorschlagssuche „W5“ führte U7 nicht unter den ersten zehn.
  function abfragen(w, signal) {
    var schluessel = w.toLowerCase();
    if (speicher[schluessel]) {
      return daten().then(function (D) {
        var s = speicher[schluessel];
        return { D: D, liste: s.liste, extra: s.extra, farbe: s.farbe, kombi: s.kombi };
      });
    }
    return Promise.all([daten(), aliasse(), zweifarb()]).then(function (a) {
      var D = a[0], ziele = aliasZiele(D, a[1], w), fw = farbFragen(D, w), kz = kombiTreffer(D, a[2], w);
      var fragen = ziele.map(function (z) { return z.frage; }).concat(fw ? fw.fragen : []);
      var kh = kombiHandles(kz);
      // Produktwort: dazu die Produktart, damit „Grundierung“ die Grundierungen findet und nicht nur zehn Sets
      var typ = !codeArtig(D, w) && !fw && !kz.length ? typWort(w, D) : '';
      var anfragen = [liveSuche(w, signal)].concat(fragen.map(function (f) { return liveSuche(f, signal); }));
      if (typ) anfragen.push(liveSuche('product_type:' + typ, signal));
      // Produktwort mit Marke („VW schleifpapier“, so sucht das Feld der Markenseite): Shopify füllt die ersten zehn mit Sets der
      // Marke. Das Wort ohne Marke noch einmal fragen und daraus nur Zubehör nehmen (22.10.2026)
      var ohneMarke = typ ? String(w).trim().split(/\s+/).filter(function (x) { return !istMarkenwort(D, norm(x)); }).join(' ') : '';
      if (ohneMarke === String(w).trim()) ohneMarke = '';
      if (ohneMarke) anfragen.push(liveSuche(ohneMarke, signal));
      return Promise.all([
        Promise.all(anfragen),
        Promise.all(kh.map(produktJs))
      ]).then(function (r) {
        var l = r[0];
        var extra = ziele.map(function (z, i) { return { z: z, l: l[i + 1] }; });
        var farbe = fw ? { gruppe: fw.gruppe, l: [].concat.apply([], l.slice(1 + ziele.length, 1 + fragen.length)) } : null;
        var kombi = kz.length ? { treffer: kz, produkte: {} } : null;
        kh.forEach(function (h, i) { if (r[1][i]) kombi.produkte[h] = r[1][i]; });
        var liste = l[0];
        var da = {};
        liste.forEach(function (p) { da[p.handle] = true; });
        function dazu(neu, nurZubehoer) {
          neu.forEach(function (p) {
            if (da[p.handle] || (nurZubehoer && /LACKSTIFT/i.test(p.title || ''))) return;
            da[p.handle] = true;
            liste.push(p);
          });
        }
        var nach = 1 + fragen.length;
        if (typ) dazu(l[nach++], false);
        if (ohneMarke) dazu(l[nach++], true);
        speicher[schluessel] = { liste: liste, extra: extra, farbe: farbe, kombi: kombi };
        return { D: D, liste: liste, extra: extra, farbe: farbe, kombi: kombi };
      });
    });
  }

  // Treffer ordnen: Lackstifte (genauer Code zuerst, Kombi-Teile eingereiht), Zubehör, Markenseite.
  // nurMarke: Feld auf einer Markenseite (data-marke); grenze: höchstens so viele Lackstifte, sonst MAX_LACK.
  function ordnen(produkte, wort, D, extra, farbe, kombi, nurMarke, grenze) {
    grenze = grenze || MAX_LACK;
    var lacke = [], zubehoer = [];
    var WN = norm(wort), mt = D ? markeImWort(D, WN) : null;
    var rest = mt ? WN.split(norm(mt.marke.key)).join('').split(norm(mt.marke.name)).join('') : WN;
    var schonDa = {};

    // Kombi-Teile (Hyundai W5 = U7 + XA) kommen aus der Kombi-Datei und nicht über aufnehmen(), dort hießen sie „U7 / W5“.
    // Ihre Sets (Standard und mit Grundierung) stehen deshalb nicht noch einmal in der Liste.
    var kz = kombi ? kombi.treffer : [];
    var kombiListe = kz.length ? kombiZeilen(kz, produkte, kombi.produkte) : [];
    var kombiH = {};
    kz.forEach(function (k) {
      k.paare.forEach(function (pa) {
        pa.teile.forEach(function (t) { if (t.h) kombiH[t.h] = true; if (t.g) kombiH[t.g] = true; });
      });
    });

    // Trägt das Set den getippten Code nicht als eigenen (VW 2T, getippt LC9X), stehen beide da, wie im Hero.
    // Steckt das Getippte schon im Code des Sets („W9877/BC“ für BC), braucht es keinen zweiten Code
    function imCode(code) {
      return String(code).split('/').some(function (s) { return norm(s) === rest; });
    }
    function aufnehmen(e, ueber) {
      var d = e.d;
      var eigen = d.code ? norm(d.code) === rest : !!(d.ton && norm(d.ton[0]) === rest);
      e.exakt = eigen || !!ueber || !!(d.codes && d.codes[rest]);
      if (e.exakt && !eigen && d.code && !imCode(d.code)) e.anzeige = d.code + ' / ' + rest;
      if (e.p.handle) schonDa[e.p.handle] = e;
      lacke.push(e);
    }

    produkte.forEach(function (p) {
      if (kombiH[p.handle]) return;
      var d = ausMetafeldern(p, D) || deuten(p.title, D);
      if (d.lack) aufnehmen({ p: p, d: d });
      else zubehoer.push({ p: p, d: d });
    });

    // Sets aus den weiteren Anfragen, nur wenn ihr Code wirklich der gefragte ist (die Anfrage „VW LC9X“
    // findet auch andere VW-Sets). Über eine andere Schreibweise zählt ein Set nur in der Farbe des Getippten
    // (VW L1278 ist „Bege Senegal“, nicht jedes Set unter VW 112), sonst in der Farbe des Ziel-Codes.
    function farbePasst(x, d) {
      if (x.z.codeN === rest || d.codes[rest] || !D) return true;
      var liste = toeneVon(D, x.z.key);
      var bezug = liste.filter(function (e) { return e.codeN === rest; });
      if (!bezug.length) bezug = liste.filter(function (e) { return e.codeN === x.z.codeN; });
      if (!bezug.length) return true;
      // Ein Set ohne Farbwert prüft der Farbname (VW 8E Beige Alteza zählt nicht für A7W)
      if (!d.ton) return bezug.some(function (e) { return namenNah(e.ton[1], d.name); });
      var hexe = bezug.map(function (e) { return e.ton[2]; }).filter(Boolean);
      return !hexe.length || hexe.some(function (h) { return dE(h, d.ton[2]) < 10; });
    }
    (extra || []).forEach(function (x) {
      x.l.forEach(function (p) {
        if (kombiH[p.handle]) return;
        var d = ausMetafeldern(p, D);
        if (!d || !d.codes[x.z.codeN] || (d.marke && d.marke.key !== x.z.key) || !farbePasst(x, d)) return;
        var da = schonDa[p.handle];
        if (da) {
          if (!da.exakt) { da.exakt = true; if (da.d.code && norm(da.d.code) !== rest && !imCode(da.d.code)) da.anzeige = da.d.code + ' / ' + rest; }
          return;
        }
        aufnehmen({ p: p, d: d }, x.z.codeN !== rest);
      });
    });

    // Treffer der Farbwort-Anfragen („weiß“ -> WHITE, BLANC): nur Lackstifte, deren Farbname ein Wort der Gruppe
    // trägt, bei getippter Marke nur diese Marke
    if (farbe) farbe.l.forEach(function (p) {
      if (schonDa[p.handle] || kombiH[p.handle]) return;
      var d = ausMetafeldern(p, D) || deuten(p.title, D);
      if (!d.lack || (mt && d.marke && d.marke.key !== mt.marke.key)) return;
      if (!farbWortIn(d.name || (d.ton ? d.ton[1] : '') || p.title, farbe.gruppe)) return;
      aufnehmen({ p: p, d: d });
    });

    // Markenseite (data-marke, 09.10.2026): nur Sets der Marke. Die Kopfsuche zeigt bei „VW LC9X“ auch Audi, Skoda und
    // Seat mit demselben Code (VW nur vorn), auf „Lackstift für VW“ wäre das ein Umweg.
    if (mt && nurMarke) {
      lacke = lacke.filter(function (e) { return !e.d.marke || e.d.marke.key === mt.marke.key; });
    }

    // Reihenfolge wie im Hero: zuerst der genau getippte Code (auch über eine andere Schreibweise), dann Sets,
    // deren Farbname das getippte Wort enthält („Verdone“ vor „Vert Jade“, das Shopify ähnlich findet), dann bei
    // einem Farbwort die Namen in anderer Sprache („grün“: Oceanicgrün vor Verde Ecologico), dann die Marke (VW vor
    // Porsche, BMW B45 vor Renault B45), sonst Shopifys Reihenfolge.
    var stufe = function (e) {
      if (e.exakt) return 0;
      var name = e.d.name || (e.d.ton ? e.d.ton[1] : '');
      // Ein Wort aus jedem Set-Titel ist kein Farbname, auch wenn es in einem Namen steht („… Berry Klarlack“)
      if ((rest.length >= 4 || farbe) && !SET_WORT.test(rest) && norm(name).indexOf(rest) >= 0) return 1;
      return farbe && farbWortIn(name, farbe.gruppe) ? 2 : 3;
    };
    if (lacke.length > 1) {
      lacke = lacke.map(function (e, i) { return { e: e, i: i, s: stufe(e) }; }).sort(function (a, b) {
        return (a.s - b.s) ||
          (rang(a.e.d.marke ? a.e.d.marke.key : '') - rang(b.e.d.marke ? b.e.d.marke.key : '')) || (a.i - b.i);
      }).map(function (x) { return x.e; });
    }
    // Produktsuche (siehe SET_WORT): kein Code, kein Farbwort, keine Marke allein, kein Set über Code oder Farbnamen.
    // Passt Zubehör, fallen Lackstifte ohne eigenes Wort weg; passt das Zubehör besser als jeder Lackstift, steht es oben.
    var produktsuche = false, zubehoerZuerst = false;
    if (!kz.length && !farbe && !codeArtig(D, wort) && !markeZu(wort, D) &&
        !lacke.some(function (e) { return stufe(e) < 3; })) {
      var qw = suchWoerter(wort), zMax = 0, lMax = 0;
      zubehoer.forEach(function (e) { e.treffer = wortTreffer(qw, e.p, false, D); zMax = Math.max(zMax, e.treffer); });
      // Erst ein Wort ausser der Marke macht es zur Produktsuche
      if (zMax >= 2) {
        produktsuche = true;
        lacke = lacke.filter(function (e) { e.treffer = wortTreffer(qw, e.p, true, D); return e.treffer > 0; });
        lacke.forEach(function (e) { lMax = Math.max(lMax, e.treffer); });
        zubehoerZuerst = zMax > lMax;
        // Zubehör ohne eines der Wörter (Shopifys Nähe: „Schleifvlies“ zu „Schleifpapier“) fällt weg, der Rest nach Treffern
        zubehoer = zubehoer.filter(function (e) { return e.treffer >= 2; }).map(function (e, i) { return { e: e, i: i }; })
          .sort(function (a, b) { return (b.e.treffer - a.e.treffer) || (a.i - b.i); }).map(function (x) { return x.e; });
      }
    }
    if (kombiListe.length) {
      // Kombi-Teile einreihen: echte Einzeltöne derselben Marke mit genau diesem Code zuerst (Hyundai IO Pansy Blue, VW 9915
      // Reinweiß), dann die Teile, dann weitere exakte Treffer (die alten „OEM MULTI TONE“-Sets bis zu ihrer Archivierung). Was
      // Shopify nur ähnlich findet (W5R, U7U, 7B zu „7U“), fällt weg, wie auf der Startseite. Ohne getippte Marke bleiben exakte
      // Treffer von Marken mit besserem RANG davor („K4“: VW K4 Königsblau vor Hyundai). Die Teile werden nie abgeschnitten; die
      // übrigen Plätze bis MAX_LACK (mindestens zwei) bekommen zuerst die Einzeltöne, sonst verdrängten bei „F9“ vier VW-Sets das
      // Hyundai-Set F9 Purple.
      var km = {}, kr = 99;
      kz.forEach(function (k) { km[k.key] = true; kr = Math.min(kr, rang(k.key)); });
      var davor = [], einzel = [], danach = [];
      lacke.forEach(function (e) {
        var key = e.d.marke ? e.d.marke.key : '';
        var eigen = e.d.code ? norm(e.d.code) === rest : !!(e.d.ton && norm(e.d.ton[0]) === rest);
        if (km[key] && eigen && !MEHRFARB.test((e.d.name || '') + ' ' + (e.p.title || ''))) einzel.push(e);
        else if (!mt && e.exakt && !km[key] && rang(key) < kr) davor.push(e);
        else if (e.exakt) danach.push(e);
      });
      var frei = Math.max(2, grenze - kombiListe.length);
      einzel = einzel.slice(0, frei); frei -= einzel.length;
      davor = davor.slice(0, frei); frei -= davor.length;
      lacke = davor.concat(einzel, kombiListe, danach.slice(0, frei));
    } else {
      lacke = lacke.slice(0, grenze);
    }
    // Ohne Lackstift oder mit Zubehör oben bekommt das Zubehör die Plätze der Lackstifte (Polieren: sechs statt drei);
    // nicht bei einer Marke allein, dort führt die Zeile zur Markenseite
    var marke = markeZu(wort, D);
    var vieleZubehoer = zubehoerZuerst || (!lacke.length && !marke);
    zubehoer = zubehoer.slice(0, vieleZubehoer ? Math.max(MAX_ZUBEHOER, grenze) : MAX_ZUBEHOER);
    return { lacke: lacke, zubehoer: zubehoer, marke: marke, produktsuche: produktsuche, zubehoerZuerst: zubehoerZuerst };
  }

  // Die Zeilen der Liste, ohne <ul>. art.frei: Liste ohne Listbox (Hero), die Links sind mit Tab erreichbar.
  // art.nurZubehoer: nur Zubehör und „Alle Treffer“, die Farbtöne zeigt der Hero selbst.
  function zeilenHtml(erg, wort, D, id, art) {
    art = art || {};
    var frei = !!art.frei, nr = 0;
    var lacke = art.nurZubehoer ? [] : erg.lacke, zubehoer = erg.zubehoer, marke = art.nurZubehoer ? null : erg.marke;
    // In der Kopfliste führt die Liste den Fokus (aria-activedescendant), die Links selbst nicht
    function li(klasse, link) {
      if (frei) return '<li class="' + klasse + '">' + link.replace(' tabindex="-1"', '') + '</li>';
      nr++;
      return '<li class="' + klasse + '" role="option" id="' + id + '-o' + nr + '" aria-selected="false">' + link + '</li>';
    }
    function hinweis(klasse, inhalt) {
      return '<li class="' + klasse + '"' + (frei ? '' : ' role="presentation"') + '>' + inhalt + '</li>';
    }
    function zeile(e) {
      return li('ds-tr-zeile' + (e.kombi ? ' ds-tr-zeile--kombi' : ''), trefferLink(e));
    }

    var html = '';

    // Wer nur eine Marke tippt, will die Markenseite und nicht fünf zufällige Artikel daraus
    if (marke) {
      html += li('ds-tr-zeile', '<a class="ds-tr ds-tr--marke" href="/collections/' + esc(marke.handle) + '" tabindex="-1">' +
        '<span class="ds-tr-probe ds-tr-probe--marke" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h10"/></svg></span>' +
        '<span class="ds-tr-text"><b>Alle ' + esc(marke.name) + '-Lackstifte</b>' +
        '<small>Zur Markenseite</small></span></a>');
    }

    var lackHtml = lacke.map(zeile).join('');
    var zubehoerHtml = zubehoer.length ? hinweis('ds-tr-kopf', 'Zubehör') + zubehoer.map(zeile).join('') : '';
    // Produktsuche mit besser passendem Zubehör: Zubehör oben, die Lackstifte mit eigener Überschrift darunter
    if (erg.zubehoerZuerst && lacke.length) html += zubehoerHtml + hinweis('ds-tr-kopf', 'Lackstifte') + lackHtml;
    else html += lackHtml + zubehoerHtml;

    /* Kein Lackstift gefunden? Dann ist das der Fall, fuer den es die Wunschfarbe gibt.
       Anton am 23.09.2026: "auch bei der suche im header genauso, selbe logik nutzen".

       Die Bedingung heisst "kein Lackstift UND keine Marke", nicht "gar nichts":
       wer "bmw" tippt, bekommt die Markenseite mit 506 Toenen und braucht kein
       Anmisch-Angebot. Dieselbe Regel wie im Hero.

       Erste Wahl bleibt die Zeile mit echtem Farbpunkt aus der Farbdatei - die weiss,
       dass es den Ton gibt und wie er aussieht. Nur wenn sie den Code gar nicht kennt,
       faellt es auf das allgemeine Angebot zurueck, und seit 21.10.2026 nur noch, wenn
       das Getippte nach einem Farbcode aussieht und kein Zubehoer passt (codeArtig):
       bei „Schleifpapier“ stand vorher unter den Schleifscheiben „Ihre Farbe anmischen lassen“. */
    if (!art.nurZubehoer && !lacke.length && !marke && !erg.produktsuche) {
      // Erst nachsehen, ob wir den Ton kennen, auch ohne fertiges Angebot.
      var offen = toeneSuchen(D, wort, 3);
      if (offen.length) {
        html += hinweis('ds-tr-kopf', 'Auf Anfrage angemischt');
        offen.forEach(function (o) {
          var t = o.ton;
          var ziel = cfg.wunsch || ((cfg.suche || '/search') + '?q=' + encodeURIComponent(wort));
          html += li('ds-tr-zeile', '<a class="ds-tr ds-tr--anfrage" href="' + esc(ziel) + '" tabindex="-1">' +
            // Auch hier das Flaeschchen: das Wunschfarbe-Set, darauf der angefragte Ton
            (cfg.wunschBild
              ? '<span class="ds-tr-foto"><img class="ds-tr-bild" src="' + esc(cfg.wunschBild) + '" alt="" width="52" height="52" loading="lazy">' +
                '<span class="ds-tr-punkt" data-lackart="' + (t[3] ? 'effekt' : 'uni') + '" style="--ton:#' + esc(t[2]) + '" aria-hidden="true"></span></span>'
              : '<span class="ds-tr-probe" data-lackart="' + (t[3] ? 'effekt' : 'uni') + '" style="background:#' + esc(t[2]) + '" aria-hidden="true"></span>') +
            '<span class="ds-tr-text"><b>' + esc(o.marke.name + ' ' + t[0]) + '</b>' +
            '<small>' + esc(t[1]) + ' · mischen wir nach Farbcode an</small></span>' +
            '<span class="ds-tr-anfrage">Wunschfarbe</span></a>');
        });
      } else {
        var code = codeArtig(D, wort);
        if (!zubehoer.length) {
          html += hinweis('ds-tr-leer', 'Kein Treffer für „' + esc(wort) + '“. ' + (code
            ? 'Prüfen Sie den Farbcode oder suchen Sie nach der Marke.'
            : 'Suchen Sie nach Ihrem Farbcode, der Automarke oder einem anderen Wort.'));
        }
        if (cfg.wunsch && code && !zubehoer.length) {
          html += li('ds-tr-zeile', '<a class="ds-tr ds-tr--anfrage" href="' + esc(cfg.wunsch) + '" tabindex="-1">' +
            (cfg.wunschBild
              ? '<img class="ds-tr-bild" src="' + esc(cfg.wunschBild) + '" alt="" width="52" height="52" loading="lazy">'
              : '<span class="ds-tr-probe ds-tr-probe--wunsch" aria-hidden="true"></span>') +
            '<span class="ds-tr-text"><b>Ihre Farbe anmischen lassen</b>' +
            '<small>Nach Ihrem Farbcode gemischt</small></span>' +
            (cfg.wunschPreis ? '<span class="ds-tr-preis">' + esc(cfg.wunschPreis) + '</span>' : '') +
            '</a>');
        }
      }
    }

    /* "Alle Treffer fuer X" nur, wenn es ueberhaupt Treffer gibt.
       Gemessen am 23.09.2026, Schnellliste gegen Volltextsuche des Shops:
           LY3F   0 -> 0      ZZ99X  0 -> 0
           dksw   0 -> 7, aber die sieben sind Ford DKS, Harley DSW und Ducati 904 -
                  Teilworttreffer, nicht das Gesuchte
       Im Leerfall fuehrt der Verweis also entweder auf eine leere Seite oder auf
       Zufallsfunde. Beides ist schlechter als nichts, weil es die Wunschfarbe direkt
       darueber entwertet. Gibt es Treffer, bleibt er - dann heisst er wirklich
       "sieh dir alle an". */
    var nichtsGefunden = !lacke.length && !zubehoer.length && !marke;
    if (!nichtsGefunden) {
      html += li('ds-tr-zeile ds-tr-zeile--alle',
        '<a class="ds-tr ds-tr--alle" href="' + esc((cfg.suche || '/search') + '?q=' + encodeURIComponent(wort) + '&options%5Bprefix%5D=last') + '" tabindex="-1">' +
        '<span>Alle Treffer für „' + esc(wort) + '“</span>' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg></a>');
    }
    return html;
  }

  /* Für Felder ohne eigenes Element (der Hero der Startseite): dieselbe Liste wie in der Kopfsuche, als fertige Zeilen ohne
     Listbox. art.grenze: höchstens so viele Lackstifte. Antwort null unter zwei Zeichen, sonst { html, zubehoerHtml, lacke,
     zubehoer, marke }: html die ganze Liste, zubehoerHtml nur Zubehör und „Alle Treffer“ (leer ohne Zubehör), dazu die Anzahlen.
     Nach dem Einsetzen fotos(wurzel) aufrufen; vorladen() holt Farbdaten, Schreibweisen und Kombi-Codes wie der erste Fokus. */
  window.dropedoSucheMotor = {
    liste: function (wort, art) {
      wort = String(wort || '').trim();
      if (wort.length < MIN) return Promise.resolve(null);
      art = art || {};
      return abfragen(wort).then(function (r) {
        var erg = ordnen(r.liste, wort, r.D, r.extra, r.farbe, r.kombi, false, art.grenze);
        return { html: zeilenHtml(erg, wort, r.D, 'lf-liste', { frei: true }),
                 zubehoerHtml: zeilenHtml(erg, wort, r.D, 'lf-liste', { frei: true, nurZubehoer: true }),
                 lacke: erg.lacke.length, zubehoer: erg.zubehoer.length, marke: !!erg.marke };
      });
    },
    fotos: fotosNachladen,
    vorladen: function () { daten(); aliasse(); zweifarb(); }
  };


  /* ---------- Das Element ---------- */

  var Basis = typeof SearchForm === 'function' ? SearchForm : HTMLElement;

  class DsSuchfeld extends Basis {
    constructor() {
      super();
      this.kasten = this.querySelector('[data-treffer]');
      this.status = this.querySelector('[data-suche-status]');
      this.abbruch = new AbortController();
      this.wort = '';

      if (!this.input || !this.kasten) return;

      this.listeId = this.kasten.id;
      this.input.addEventListener('focus', this.aufFokus.bind(this));
      this.addEventListener('focusout', this.aufFokusWeg.bind(this));
      this.addEventListener('keydown', this.aufTaste.bind(this));
      this.input.form.addEventListener('submit', this.aufAbsenden.bind(this));
      // Klick auf eine Zeile soll den Fokus nicht aus dem Feld nehmen, sonst schliesst die Liste zu früh
      this.kasten.addEventListener('mousedown', function (e) { e.preventDefault(); });
      this.input.addEventListener('focus', function () { daten(); aliasse(); zweifarb(); }, { once: true });
      this.input.addEventListener('focus', this.hochholen.bind(this));
    }

    onChange() {
      if (typeof super.onChange === 'function') super.onChange();
      var w = this.input.value.trim();
      this.wort = w;
      this.eingabe = w;
      if (w.length < MIN) { this.zu(); return; }
      if (!this.getAttribute('data-marke')) { this.holen(w); return; }
      // Markenseite: erst die Markenliste, dann wissen wir, ob die Eingabe schon eine Marke traegt
      var self = this;
      daten().then(function (D) {
        if (self.eingabe !== w) return;   // inzwischen weitergetippt
        self.wort = self.mitMarke(w, D);
        self.holen(self.wort);
      });
    }

    /* Suchfeld auf einer Markenseite (data-marke, VW-Muster 09.10.2026): Wer auf „Lackstift für VW“ steht und
       „LC9X“ tippt, meint VW LC9X und nicht Audi, Seat, Skoda und Porsche mit demselben Code. Die Suche laeuft deshalb
       als „VW LC9X“ und nimmt damit denselben Weg wie eine Eingabe mit Marke (markeImWort). Tippt jemand selbst
       eine Marke, gilt seine. Verglichen wird wortweise: markeImWort sucht Teilstuecke, und kurze Markenwoerter
       wie MG koennten sonst mitten in einem Code stecken. */
    mitMarke(w, D) {
      var marke = this.getAttribute('data-marke');
      if (!marke || !D || !D.marken) return w;
      var woerter = w.toUpperCase().split(/[^A-Z0-9ÄÖÜ]+/).filter(Boolean);
      var hatMarke = D.marken.some(function (m) {
        return m.woerter.some(function (x) { return woerter.indexOf(x) >= 0; });
      });
      return hatMarke ? w : marke + ' ' + w;
    }

    onFormReset(event) {
      if (typeof super.onFormReset === 'function') super.onFormReset(event);
      this.wort = '';
      this.eingabe = '';
      this.zu();
    }

    aufFokus() {
      var w = this.input.value.trim();
      if (w.length < MIN) return;
      if (w !== (this.eingabe || this.wort)) { this.onChange(); return; }
      if (this.kasten.innerHTML.trim()) this.auf();
    }

    // Unten auf der Seite (Abschluss der Startseite) oeffnete die Liste sonst hinter der
    // Bildschirmtastatur. Am Telefon holt der Fokus das Feld unter die Kopfzeile; im Kopf
    // selbst und auf der Suchseite steht es ohnehin oben, dort passiert nichts.
    hochholen() {
      if (!window.matchMedia || !window.matchMedia('(max-width: 820px)').matches) return;
      var self = this;
      setTimeout(function () {
        var r = self.getBoundingClientRect();
        var kopf = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dh-hoehe')) || 61;
        if (r.top > window.innerHeight * 0.3) window.scrollBy({ top: r.top - kopf - 12, behavior: 'smooth' });
      }, 250);
    }

    aufFokusWeg() {
      var self = this;
      setTimeout(function () {
        if (!self.contains(document.activeElement)) self.zu();
      }, 0);
    }

    aufAbsenden(event) {
      if (!this.input.value.trim().length) { event.preventDefault(); return; }
      // Markenseite: die Suchseite bekommt dieselbe Anfrage wie die Liste, also mit Marke
      if (this.getAttribute('data-marke') && this.wort && this.eingabe === this.input.value.trim()) this.input.value = this.wort;
    }

    aufTaste(event) {
      switch (event.code) {
        case 'ArrowUp':
          event.preventDefault();
          this.schieben(-1);
          break;
        case 'ArrowDown':
          event.preventDefault();
          this.schieben(1);
          break;
        case 'Escape':
          if (this.getAttribute('offen')) { event.preventDefault(); this.zu(); this.input.focus(); }
          break;
        case 'Enter':
          var gewaehlt = this.kasten.querySelector('[aria-selected="true"]');
          if (!gewaehlt) return;
          event.preventDefault();
          var ziel = gewaehlt.querySelector('a');
          if (ziel) ziel.click();
          else this.input.form.submit();
          break;
      }
    }

    schieben(richtung) {
      if (!this.getAttribute('offen')) return;
      var alle = Array.prototype.slice.call(this.kasten.querySelectorAll('[role="option"]'));
      if (!alle.length) return;
      var jetzt = this.kasten.querySelector('[aria-selected="true"]');
      var i = alle.indexOf(jetzt);
      var neu = i < 0 ? (richtung > 0 ? 0 : alle.length - 1) : (i + richtung + alle.length) % alle.length;
      if (jetzt) jetzt.setAttribute('aria-selected', 'false');
      alle[neu].setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', alle[neu].id);
      if (alle[neu].scrollIntoView) alle[neu].scrollIntoView({ block: 'nearest' });
    }

    holen(w) {
      var self = this;
      this.melden(cfg.textLaedt || 'Suche läuft');
      // Schon einmal gefragt: dann kommt die Liste aus dem Speicher und eine laufende Anfrage darf weiterlaufen
      if (!speicher[w.toLowerCase()]) {
        this.abbruch.abort();
        this.abbruch = new AbortController();
      }
      abfragen(w, this.abbruch.signal).then(function (r) {
        if (self.wort === w) self.zeichnen(r.liste, w, r.D, r.extra, r.farbe, r.kombi);
      }).catch(function (e) {
        if (e && e.name === 'AbortError') return;
        self.zu();
      });
    }

    zeichnen(produkte, wort, D, extra, farbe, kombi) {
      var erg = ordnen(produkte, wort, D, extra, farbe, kombi, !!this.getAttribute('data-marke'));
      this.kasten.innerHTML = '<ul class="ds-tr-liste" role="listbox" aria-label="Suchtreffer">' +
        zeilenHtml(erg, wort, D, this.listeId) + '</ul>';
      fotosNachladen(this.kasten);
      this.input.removeAttribute('aria-activedescendant');
      this.auf();

      var anzahl = erg.lacke.length + erg.zubehoer.length;
      this.melden(anzahl === 0
        ? 'Kein Treffer für ' + wort
        : anzahl + (anzahl === 1 ? ' Treffer' : ' Treffer') + ' für ' + wort);
    }

    auf() {
      this.setAttribute('offen', 'true');
      this.kasten.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    zu() {
      this.removeAttribute('offen');
      this.kasten.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      var gewaehlt = this.kasten.querySelector('[aria-selected="true"]');
      if (gewaehlt) gewaehlt.setAttribute('aria-selected', 'false');
    }

    melden(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  if (!customElements.get('ds-suchfeld')) customElements.define('ds-suchfeld', DsSuchfeld);

  /* Suchseite (sections/main-search.liquid): Ist das Suchwort ein Kombi-Code, stehen die Teile in einem Kasten über dem Raster.
     Das Raster ordnet Shopify selbst; dort stünden die Teile unbeschriftet zwischen W5R & Co. oder fehlten ganz (Codes ohne
     Schlagwort wie Hyundai IO). Das Angebot „Als Wunschfarbe anmischen“ für das ganze Suchwort (snippets/ds-kein-treffer.liquid)
     verschwindet dann: einen Kombi-Code mischt niemand als einen Ton. */
  function suchseite() {
    var box = document.querySelector('[data-zweifarb-hinweis]');
    if (!box || !cfg.zweifarb) return;
    var wort = box.getAttribute('data-suchwort') || '';
    if (norm(wort).length < MIN) return;
    Promise.all([daten(), zweifarb()]).then(function (a) {
      var kz = kombiTreffer(a[0], a[1], wort);
      if (!kz.length) return null;
      var kh = kombiHandles(kz);
      return Promise.all(kh.map(produktJs)).then(function (pj) {
        var je = {};
        kh.forEach(function (h, i) { if (pj[i]) je[h] = pj[i]; });
        var zeilen = kombiZeilen(kz, [], je);
        if (!zeilen.length) return;
        var alleMitSet = kz.every(function (k) { return k.paare.every(function (pa) { return pa.teile.every(function (t) { return t.h; }); }); });
        box.innerHTML = '<p class="ds-zf-kopf">' + esc('Zweifarbige Lackierung ' + kz.map(function (k) { return k.marke.name + ' ' + k.code; }).join(', ')) +
          '</p>' + (alleMitSet ? '<p class="ds-zf-unter">Jede Farbe ist ein eigenes Set.</p>' : '') + '<ul class="ds-tr-liste">' +
          zeilen.map(function (e) { return '<li class="ds-tr-zeile ds-tr-zeile--kombi">' + trefferLink(e, true) + '</li>'; }).join('') + '</ul>';
        fotosNachladen(box);
        box.hidden = false;
        var leer = document.querySelector('.dlr');
        if (leer) leer.hidden = true;
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suchseite);
  else suchseite();
})();
